export const ORGANIZATION_RECIPES = "Organization Recipes";
export const ORG_GROUP_RECIPES = "Org Group Recipes";
export const STAFF_RECIPES = "Recipes";
